import linkArrow from "../../../images/link-arrow.png";
import sliderArrow from "../../../images/slider-arrow-green.png";

export default theme => ({
    vacancySlider: {
        position: 'relative',
        marginBottom: 36,
        paddingTop: 90,
        paddingBottom: 50,
        '&::before': {
            backgroundColor: theme.palette.secondary.main,
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: '50%',
            width: '100vw',
            transform: 'translateX(-50%)',
            content: '""',
            display: 'block',
        },
        '& h2': {
            marginTop: 0,
            marginBottom: 40,
            fontSize: 24,
            fontWeight: 'bold',
            letterSpacing: '0.056em',
            lineHeight: 1.25,
            color: theme.palette.secondary.contrastText,
            textTransform: 'uppercase',
            position: 'relative',
            zIndex: 1,
            [theme.breakpoints.up('md')]: {
                fonSize: 32,
                lineHeight: 1.2,
            },
            '&::before' : {
                width: 40,
                height: 4,
                content: '""',
                display: 'block',
                marginBottom: 16,
                backgroundColor: theme.palette.primary.main,
            }
        },
        '& .slick-slider': {
            zIndex: 1,
            paddingBottom: 50,
            [theme.breakpoints.up('md')]: {
                paddingBottom: 75,
            },
            '& .slide': {
                backgroundColor: theme.palette.background.default,
                position: 'relative',
                marginTop: 29,
                [theme.breakpoints.up('md')]: {
                    paddingLeft: 'calc(100% - 350px)',
                    marginTop: 0,
                },
                [theme.breakpoints.up('lg')]: {
                    paddingLeft: 'calc(100% - 450px)',
                },
                '& .tags': {
                    position: 'absolute',
                    top: -29,
                    left: 0,
                    zIndex: 2,
                    [theme.breakpoints.up('md')]: {
                        top: 0,
                    },
                    '& div': {
                        fontSize: 12,
                        letterSpacing: '0.04em',
                        padding: '6px 10px',
                        display: 'inline-block',
                        backgroundColor: '#72B5CC',
                        color: theme.palette.common.white,
                        fontFamily: theme.headerFont,
                        textTransform: 'uppercase',
                        [theme.breakpoints.up('md')]: {
                            padding: '10px 12px',
                            fontSize: 14,
                        },
                        '&.new': {
                            backgroundColor: '#72CE9B',
                        },
                        '&.featured': {
                            backgroundColor: '#865F7F',
                        }
                    }
                },
                '& .vacancy-image': {
                    [theme.breakpoints.up('md')]: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 350,
                    },
                    [theme.breakpoints.up('lg')]: {
                        right: 450,
                    },
                },
                '& .ooh': {
                    color: theme.palette.primary.main,
                    fontStyle: 'italic',
                    fontSize: 20,
                    lineHeight: 1.5,
                    letterSpacing: '0.056em',
                    padding: 24,
                    [theme.breakpoints.up('md')]: {
                        borderBottom: '1px solid ' + theme.palette.secondary.main,
                        fontSize: 28,
                        padding: 52,
                        lineHeight: 1.25,
                    },
                    '&.desktop': {
                        display: 'none',
                        [theme.breakpoints.up('md')]: {
                            display: 'block',
                        }
                    },
                    '&.mobile': {
                        [theme.breakpoints.up('md')]: {
                            display: 'none',
                        }
                    }
                },
                '& .vacancy-info': {
                    '& .vacancy-name': {
                        padding: '16px 24px',
                        borderBottom: '1px solid ' + theme.palette.secondary.main,
                        [theme.breakpoints.up('md')]: {
                            padding: '60px 52px',
                        },
                        '& h3': {
                            margin: 0,
                            textTransform: 'uppercase',
                            lineHeight: 1.5,
                            letterSpacing: '0.04em',
                            fontSize: 18,
                            [theme.breakpoints.up('md')]: {
                                fontSize: 32,
                                lineHeight: 1.2,
                            },
                        },
                        '& p': {
                            lineHeight: 2,
                            fontSize: 16,
                            fontStyle: 'italic',
                            letterSpacing: '0.032em',
                            margin: 0,
                            [theme.breakpoints.up('md')]: {
                                fontSize: 18,
                            },
                        },
                    },
                    '& a': {
                        fontSize: 16,
                        fontWeight: 'bold',
                        padding: '16px 24px',
                        lineHeight: 1.2,
                        textTransform: 'uppercase',
                        fontFamily: theme.headerFont,
                        color: theme.palette.primary.main,
                        transition: 'color .3s ease-in-out',
                        display: 'block',
                        textDecoration: 'none',
                        letterSpacing: '0.06em',
                        backgroundColor: '#72ce9b',
                        '&:hover, &:focus': {
                            color: theme.palette.primary.dark,
                        },
                        [theme.breakpoints.up('md')]: {
                            padding: '32px 52px',
                        },
                        '&::after': {
                            marginTop: 3,
                            width: 26,
                            height: 13,
                            display: 'inline-block',
                            marginLeft: 15,
                            backgroundImage: 'url(' + linkArrow + ')',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'contain',
                            content: '""',
                            float: 'right',
                        },
                    }
                }
            },
            '& .slick-dots': {
                bottom: 4,
                [theme.breakpoints.up('md')]: {
                    bottom: -6,
                },
                '& li': {
                    width: 12,
                    height: 12,
                    margin: '0 12px',
                    [theme.breakpoints.up('md')]: {
                        width: 20,
                        height: 20,
                        margin: 10,
                    },
                    '& button': {
                        width: 12,
                        height: 12,
                        backgroundColor: theme.palette.common.white,
                        borderRadius: '50%',
                        '&::before': {
                            content: '""',
                        },
                        [theme.breakpoints.up('md')]: {
                            width: 20,
                            height: 20,
                        }
                    },
                    '&.slick-active': {
                        position: 'relative',
                        '& button': {
                            backgroundColor: theme.palette.primary.main,
                            '&::before': {
                                border: '2px solid',
                                borderColor: theme.palette.primary.main,
                                borderRadius: '50%',
                                top: -3,
                                left: -3,
                                width: 18,
                                height: 18,
                                backgroundColor: 'transparent',
                                position: 'absolute',
                                [theme.breakpoints.up('md')]: {
                                    top: -5,
                                    left: -5,
                                    width: 30,
                                    height: 30,
                                }
                            }
                        }
                    }
                }
            },
            '& .slick-next': {
                width: 18,
                height: 18,
                backgroundImage: 'url(' + sliderArrow + ') !important',
                backgroundSize: 'contain !important',
                backgroundPosition: 'center !important',
                backgroundRepeat: 'no-repeat !important',
                top: 'auto',
                right: 25,
                bottom: 0,
                transform: 'none',
                zIndex: 10,
                '&::before': {
                    display: 'none',
                },
                '&.slick-disabled': {
                    opacity: 0.25,
                },
            },
            '& .slick-prev': {
                width: 18,
                height: 18,
                backgroundImage: 'url(' + sliderArrow + ') !important',
                backgroundSize: 'contain !important',
                backgroundPosition: 'center !important',
                backgroundRepeat: 'no-repeat !important',
                top: 'auto',
                left: 25,
                bottom: 0,
                transform: 'rotate(180deg)',
                zIndex: 10,
                '&::before': {
                    display: 'none',
                },
                '&.slick-disabled': {
                    opacity: 0.25,
                },
            }
        }
    },
    vacancySliderTheme: {
        ...theme.vacancySliderTheme,
    }
})